function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 20 20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 5h2v7h-2z",
    fill: "rgb(0,0,0)",
    style: {
      fill: "rgb(255, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 13h2v2h-2z",
    fill: "rgb(0,0,0)",
    style: {
      fill: "rgb(255, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 0c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z",
    fill: "rgb(0,0,0)",
    style: {
      fill: "rgb(255, 0, 0)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.6de1b71deaae8983cee1609f60cc6873.svg";
export { ForwardRef as ReactComponent };